export const products = [
  {
    id: 1,
    name: 'Whole Milk Sample',
    price: 65,
    image: '🥛',
    description: 'Fresh whole milk, 1 liter',
    category: 'Fresh Milk',
    fat: '3.5%'
  },
  {
    id: 2,
    name: 'Toned Milk',
    price: 55,
    image: '🥛',
    description: 'Healthy toned milk, 1 liter',
    category: 'Fresh Milk',
    fat: '3%'
  },
  {
    id: 3,
    name: 'Skimmed Milk',
    price: 50,
    image: '🥛',
    description: 'Low fat skimmed milk, 1 liter',
    category: 'Fresh Milk',
    fat: '0.5%'
  },
  {
    id: 4,
    name: 'Flavored Milk - Chocolate',
    price: 35,
    image: '🍫',
    description: 'Delicious chocolate milk, 200ml',
    category: 'Flavored',
    fat: '3%'
  },
  {
    id: 5,
    name: 'Flavored Milk - Strawberry',
    price: 35,
    image: '🍓',
    description: 'Sweet strawberry milk, 200ml',
    category: 'Flavored',
    fat: '3%'
  },
  {
    id: 6,
    name: 'Buttermilk',
    price: 30,
    image: '🥤',
    description: 'Refreshing buttermilk, 500ml',
    category: 'Dairy',
    fat: '1%'
  },
  {
    id: 7,
    name: 'Paneer',
    price: 120,
    image: '🧀',
    description: 'Fresh cottage cheese, 200g',
    category: 'Dairy',
    fat: '20%'
  },
  {
    id: 8,
    name: 'Curd',
    price: 40,
    image: '🥣',
    description: 'Fresh homemade curd, 500g',
    category: 'Dairy',
    fat: '4%'
  },
  {
    id: 9,
    name: 'Fresh Bananas',
    price: 60,
    image: '🍌',
    description: 'Ripe yellow bananas, 1 dozen',
    category: 'Fruits',
    weight: '1.5kg'
  },
  {
    id: 10,
    name: 'Red Apples',
    price: 180,
    image: '🍎',
    description: 'Crisp red apples from Kashmir, 1kg',
    category: 'Fruits',
    weight: '1kg'
  },
  {
    id: 11,
    name: 'Green Grapes',
    price: 120,
    image: '🍇',
    description: 'Sweet seedless green grapes, 500g',
    category: 'Fruits',
    weight: '500g'
  },
  {
    id: 12,
    name: 'Fresh Oranges',
    price: 80,
    image: '🍊',
    description: 'Juicy Nagpur oranges, 1kg',
    category: 'Fruits',
    weight: '1kg'
  },
  {
    id: 13,
    name: 'Mango (Alphonso)',
    price: 350,
    image: '🥭',
    description: 'Premium Alphonso mangoes, 1kg',
    category: 'Fruits',
    weight: '1kg'
  },
  {
    id: 14,
    name: 'Fresh Strawberries',
    price: 200,
    image: '🍓',
    description: 'Sweet and juicy strawberries, 250g',
    category: 'Fruits',
    weight: '250g'
  },
  {
    id: 15,
    name: 'Pineapple',
    price: 90,
    image: '🍍',
    description: 'Fresh whole pineapple, 1 piece',
    category: 'Fruits',
    weight: '1.5kg'
  },
  {
    id: 16,
    name: 'Watermelon',
    price: 40,
    image: '🍉',
    description: 'Sweet red watermelon, 1kg',
    category: 'Fruits',
    weight: '1kg'
  },
  {
    id: 17,
    name: 'Fresh Pomegranate',
    price: 150,
    image: '🍈',
    description: 'Antioxidant-rich pomegranate, 500g',
    category: 'Fruits',
    weight: '500g'
  },
  {
    id: 18,
    name: 'Kiwi Fruits',
    price: 180,
    image: '🥝',
    description: 'Fresh New Zealand kiwi, 6 pieces',
    category: 'Fruits',
    weight: '300g'
  }
];
export const featureSections = [];
/*export const featureSections = [
  {
    id: 1,
    name: "Today's Deals",
    slug: 'todays-deals',
    icon: 'fas fa-bolt',
    color: '#f59e0b',
    products: [
      { id: 101, name: 'Whole Milk', price: 70, sale_price: 59, image: '🥛', category: 'Fresh Milk', fat: '3.5%', weight: '1', unit: 'kg' },
      { id: 102, name: 'Paneer', price: 140, sale_price: 109, image: '🧀', category: 'Dairy', weight: '200', unit: 'g' },
      { id: 103, name: 'Red Apples', price: 200, sale_price: 159, image: '🍎', category: 'Fruits', weight: '1', unit: 'kg' },
      { id: 104, name: 'Alphonso Mango', price: 400, sale_price: 320, image: '🥭', category: 'Fruits', weight: '1', unit: 'kg' },
      { id: 105, name: 'Curd', price: 50, sale_price: 39, image: '🥣', category: 'Dairy', weight: '500', unit: 'g' },
    ]
  },
  {
    id: 2,
    name: 'Fresh Dairy',
    slug: 'fresh-dairy',
    icon: 'fas fa-cheese',
    color: '#3b82f6',
    products: [
      { id: 201, name: 'Toned Milk', price: 55, image: '🥛', category: 'Fresh Milk', fat: '3%', weight: '1', unit: 'kg' },
      { id: 202, name: 'Skimmed Milk', price: 50, image: '🥛', category: 'Fresh Milk', fat: '0.5%', weight: '1', unit: 'kg' },
      { id: 203, name: 'Buttermilk', price: 30, image: '🥤', category: 'Dairy', fat: '1%', weight: '500', unit: 'ml' },
      { id: 204, name: 'Paneer', price: 130, image: '🧀', category: 'Dairy', weight: '200', unit: 'g' },
      { id: 205, name: 'Curd', price: 45, image: '🥣', category: 'Dairy', weight: '500', unit: 'g' },
      { id: 206, name: 'Chocolate Milk', price: 35, image: '🍫', category: 'Flavored', fat: '3%', weight: '200', unit: 'ml' },
    ]
  },
  {
    id: 3,
    name: 'Fresh Fruits',
    slug: 'fresh-fruits',
    icon: 'fas fa-apple-alt',
    color: '#10b981',
    products: [
      { id: 301, name: 'Bananas', price: 60, image: '🍌', category: 'Fruits', weight: '1.5', unit: 'kg' },
      { id: 302, name: 'Red Apples', price: 180, image: '🍎', category: 'Fruits', weight: '1', unit: 'kg' },
      { id: 303, name: 'Green Grapes', price: 120, image: '🍇', category: 'Fruits', weight: '500', unit: 'g' },
      { id: 304, name: 'Oranges', price: 80, image: '🍊', category: 'Fruits', weight: '1', unit: 'kg' },
      { id: 305, name: 'Strawberries', price: 200, image: '🍓', category: 'Fruits', weight: '250', unit: 'g' },
      { id: 306, name: 'Kiwi', price: 180, image: '🥝', category: 'Fruits', weight: '300', unit: 'g' },
    ]
  }
];
*/
export const banners = [
 
  {
    id: 1,
    title: 'Exotic Imported Fruits',
    subtitle: 'Pineapple · Grapes · Mango & More',
    background: 'from-amber-400 to-orange-600',
    icon: '🥭',
    offer: 'Up to 30% Off',
    bgStyle: 'linear-gradient(135deg, #d97706 0%, #ea580c 100%)',
    images: [
      '/uploads/products/thumbnails/1769933524_697f0ad4449bd_thumb.webp',
      '/uploads/products/thumbnails/1769933999_697f0caf76a34_thumb.webp',
      '/uploads/products/thumbnails/1771300286_6993e5be66be0_thumb.webp',
      '/uploads/products/thumbnails/1769934754_697f0fa28884c_thumb.webp',
      '/uploads/products/thumbnails/1769935550_697f12beef05d_thumb.webp',
    ]
  },
  {
    id: 2,
    title: 'Season Fruits Sale',
    subtitle: 'Strawberry · Watermelon · Banana',
    background: 'from-rose-400 to-pink-600',
    icon: '🍓',
    offer: 'Best Season Price',
    bgStyle: 'linear-gradient(135deg, #f43f5e 0%, #db2777 100%)',
    images: [
      '/uploads/products/thumbnails/1769933221_697f09a5ec10d_thumb.webp',
      '/uploads/products/thumbnails/1769933313_697f0a01b1b90_thumb.webp',
      '/uploads/products/thumbnails/1769934810_697f0fda344ad_thumb.webp',
      '/uploads/products/thumbnails/1769934927_697f104f6265c_thumb.webp',
      '/uploads/products/thumbnails/1769321140_6975b2b45b893_thumb.webp',
    ]
  },
   
  {
    id: 3,
    title: 'Subscribe & Save 10%',
    subtitle: 'Get Daily Essentials Delivered',
    background: 'from-emerald-500 to-teal-600',
    icon: '🔔',
    offer: 'Special Offer',
    bgStyle: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)'
  },
  {
    id: 4,
    title: 'Pure & Natural',
    subtitle: '100% Organic Farm Products',
    background: 'from-violet-500 to-purple-700',
    icon: '🌾',
    offer: 'Premium Quality',
    bgStyle: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)'
  },{
    id: 5,
    title: 'Fresh Milk Daily',
    subtitle: 'Farm to Doorstep in 24 Hours',
    background: 'from-blue-500 to-blue-700',
    icon: '🥛',
    offer: 'Free Delivery',
    bgStyle: 'linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)'
  }
];

export const deliverySlots = [
  { id: 'morning', time: '6:00 AM - 8:00 AM', icon: '🌅', label: 'Morning' },
  { id: 'afternoon', time: '2:00 PM - 4:00 PM', icon: '☀️', label: 'Afternoon' },
  { id: 'evening', time: '6:00 PM - 8:00 PM', icon: '🌆', label: 'Evening' }
];

export const subscriptionPlans = [
  { id: 'daily', name: 'Daily', price: 1800, duration: 30, discount: 10 },
  { id: 'alternate', name: 'Alternate Days', price: 900, duration: 30, discount: 5 },
  { id: 'weekly', name: 'Weekly (7 days)', price: 420, duration: 7, discount: 5 }
];

export const notifications = [
  { id: 1, title: 'Order Delivered', message: 'Your order #1235 has been delivered', time: '2 hours ago', unread: true },
  { id: 2, title: 'Special Offer', message: 'Get 20% off on your next subscription', time: '1 day ago', unread: true },
  { id: 3, title: 'Payment Successful', message: 'Payment of ₹190 received', time: '2 days ago', unread: false }
];

export const locations = [
  'Gurugram, Haryana',
  // 'Delhi, Delhi',
  //'Noida, Uttar Pradesh',
 // 'Ghaziabad, Uttar Pradesh',
 // 'Faridabad, Haryana'
];

 export const mockSuggestions = (query = '') => [
      { address: `${query}, MG Road, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Cyber City, Gurugram, Haryana 122002`, city: 'Gurugram', pincode: '122002' },
      { address: `${query}, Golf Course Road, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Udyog Vihar, Gurugram, Haryana 122016`, city: 'Gurugram', pincode: '122016' },
      { address: `${query}, Sohna Road, Gurugram, Haryana 122018`, city: 'Gurugram', pincode: '122018' },
      { address: `${query}, Palam Vihar, Gurugram, Haryana 122017`, city: 'Gurugram', pincode: '122017' },
      { address: `${query}, Sector 56, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 14, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 22, Gurugram, Haryana 122015`, city: 'Gurugram', pincode: '122015' },
      { address: `${query}, Sector 45, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 50, Gurugram, Haryana 122018`, city: 'Gurugram', pincode: '122018' },
      { address: `${query}, Sector 29, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, DLF Phase 3, Gurugram, Haryana 122002`, city: 'Gurugram', pincode: '122002' },
      { address: `${query}, Sushant Lok, Gurugram, Haryana 122009`, city: 'Gurugram', pincode: '122009' },
      { address: `${query}, Sector 37, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 49, Gurugram, Haryana 122018`, city: 'Gurugram', pincode: '122018' },
      { address: `${query}, Sector 31, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 44, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 57, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 26, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 46, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 58, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 27, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 47, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 59, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 28, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 48, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 60, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 29, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 49, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 61, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 30, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 50, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 62, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 31, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 51, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 63, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 32, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 52, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 64, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 33, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 53, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 65, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 34, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 54, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 66, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 35, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 55, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 67, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 36, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 56, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 68, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 37, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 57, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 69, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 38, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 58, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 70, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 39, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 59, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 71, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 40, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 60, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 72, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 41, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 61, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 73, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 42, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 62, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 74, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 43, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 63, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 75, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 44, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 64, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 76, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 45, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 65, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 77, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 46, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 66, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 78, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 47, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 67, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 79, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 48, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 68, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 80, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 49, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 69, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 81, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 50, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 70, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 82, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 51, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 71, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 83, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 52, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 72, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 84, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 53, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 73, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 85, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 54, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 74, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 86, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 55, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 75, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 87, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 56, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 76, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 88, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 57, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 77, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 89, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 58, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 78, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 90, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 59, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 79, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 91, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 60, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 80, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 92, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 61, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 81, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 93, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 62, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 82, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 94, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 63, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 83, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 95, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 64, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 84, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 96, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 65, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 85, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 97, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 66, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 86, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 98, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 67, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 87, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 99, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 68, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 88, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 100, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 69, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 89, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 101, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 70, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 90, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 102, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 71, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 91, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 103, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 72, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 92, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 104, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 73, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 93, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 105, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 74, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 94, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 106, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 75, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 95, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 107, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 76, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 96, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 108, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 77, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 97, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 109, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 78, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 98, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 110, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 79, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 99, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 111, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' },
      { address: `${query}, Sector 80, Gurugram, Haryana 122001`, city: 'Gurugram', pincode: '122001' },
      { address: `${query}, Sector 100, Gurugram, Haryana 122003`, city: 'Gurugram', pincode: '122003' },
      { address: `${query}, Sector 112, Gurugram, Haryana 122011`, city: 'Gurugram', pincode: '122011' }
    ];


     // Category icons mapping
  export const categoryIcons = {
    'All': '🛒',
    'Fresh Milk': '🥛',
    'Flavored': '🍫',
    'Dairy': '🧀',
    'Fruits': '🥭',
    'Butter': '🧈',
    'Curd': '🥣',
    'Paneer': '🧀',
    'Beverages': '🧃',
    'Snacks': '🍪',
    'Breakfast': '🍳',
    'Grocery': '🛍️',
    'Household': '🏠',
    'Personal Care': '🧴',
    'Vegetables': '🥦',
    'Bakery': '🍞',
    'Eggs': '🥚',
    'Seasonal Fruits': '🍊',
    'Citrus Fruits': '🍋',
    'Tropical Fruits': '🥭',
    'Exotic Fruits': '🍍',
    'Mens Wear': '👔',
    'Womens Wear': '👗',
    'Kids Wear': '🧒',
    'Accessories': '👜',
    'Footwear': '👟',
    'Electronics': '📱',
    'Home Appliances': '🏡',
    'Toys': '🧸',
    'Books': '📚',
    'Stationery': '✏️',
    'Gifts': '🎁',
    'Offers': '🏷️',
    'New Arrivals': '🆕',
    'Best Sellers': '🔥',
    'Organic': '🌿',
    'Vegan': '🥗',
    'Gluten-Free': '🚫🌾',
    'Cakes': '🍰',
    'Pasta': '🍝',
    'Rice': '🍚',
    'Spices': '🌶️',
    'Sauces': '🍯',
    'Snacks': '🍿',
    'Beverages': '☕',
    'Dairy Products': '🧀',
    'Bakery Items': '🥐',
    'Fruits & Vegetables': '🍎',
    'Flowers': '🌸',
    'Plants': '🌵',
    'Dining': '🍽️',
    'Kitchen': '🍳',
    'Cleaning Supplies': '🧼',
    'Health & Wellness': '💊',
    'Beauty Products': '💄',
    'Baby Care': '🍼',
    'Dinner': '🍽️',
    'Lunch': '🥪',
    'Breakfast': '🍳',
    'Tea': '🍵',
    'Coffee': '☕',
    'Juice': '🧃',
    'Imported Fruits': '🍎',
  };
